import {useField} from 'formik'
import {FC} from 'react'

import {FormSection} from '@/components/common/form/FormSection'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'
import {VerificationTrademarkTypeValue} from '@/utils/constants'

import {FormCardOption} from '../../common/form/inputs/FormCardOption'

type TrademarkSelectionProps = {
  isAnimated?: boolean
  animationStarted?: boolean
}

export const TrademarkSelection: FC<React.PropsWithChildren<TrademarkSelectionProps>> = ({
  isAnimated,
  animationStarted,
}) => {
  const {t} = useTranslation()
  const [field, , {setValue}] = useField<VerificationTrademarkTypeValue>('typeValue')
  const {title, options} = useTrademarkVerificationContent().trademarkType

  return (
    <>
      <FormSection title={t(title)} isAnimated={isAnimated} animationStarted={animationStarted}>
        <ul>
          {Object.entries(options).map(
            ([key, {imageSrc, imageAlt, title, subtitle, type, dataTest}]) => {
              const isSelected = field.value === key

              return (
                <FormCardOption
                  key={key}
                  name="type"
                  value={type}
                  title={t(title)}
                  subtitle={t(subtitle)}
                  description={t(options[field.value]?.description)}
                  isDescriptionVisible={isSelected}
                  imageSrc={imageSrc}
                  imageAlt={imageAlt}
                  isSelected={isSelected}
                  onClick={() => setValue(key as VerificationTrademarkTypeValue)}
                  dataTest={dataTest}
                />
              )
            },
          )}
        </ul>
      </FormSection>
    </>
  )
}
